var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78 19.25h7.436c.564 0 1.008-.468.896-1.021C13.802 16.7 12.787 14 9.498 14c-3.289 0-4.303 2.701-4.613 4.229-.113.553.331 1.021.896 1.021zM15.747 14c2.079 0 2.93 2.148 3.273 3.696.186.836-.49 1.554-1.346 1.554h-.927M9.498 10.25a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5zM14.747 10.25c1.519 0 2.5-1.231 2.5-2.75s-.981-2.75-2.5-2.75",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconPeople);
export default __webpack_public_path__ + "static/media/nav-icon-people.fe29206ec2879d839ea85d34d14ef63c.svg";
export { ForwardRef as ReactComponent };